var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03707,
    y: 0.958213,
    width: 24.7613,
    height: 24.7613,
    rx: 12.3806,
    stroke: "white",
    strokeWidth: 0.79875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5358 10.7029H16.0543M16.0543 10.7029V15.2214M16.0543 10.7029L10.7826 15.9746",
    stroke: "white",
    strokeWidth: 1.11825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.2cb5fbb2c91ffdc348b4ffee604b41cb.svg";
export { ForwardRef as ReactComponent };